module.exports = __webpack_public_path__ + "assets/img/Type E (21).dd4627d1.jpg";